

const PublicationScript = [
    {
        title: "Multiphase-field approach to grain boundary- and triple junction-induced barrierless premelting of polycrystals and size-effect. Newton, Anup Basak. The Journal of Chemical Physics 162, 124714 (2025).",
        link: "",
        modal: false,
    },
    {
        title: "A. Aziz, T.J. Thashreef, B. Balakrishnan, S.M. Maliyekkal, Calcium-reinforced graphene oxide-biopolymer nanocomposite: A novel and sustainable sizing agent for enhancing E-glass fibers strength and adhesion in cement composites, Composites Part A: Applied Science and Manufacturing, 192, 2025, 108808.",
        link: "",
        modal: false,
    },
    {
        title: "Self-assembled and highly faceted Mn-doped vanadium pentoxide nanorods for supercapacitor electrode; T. Keerthana, M.V. Arularasu, P. Mohanapriya, Koteswara Rao Bommisetti, Mohammed Mujahid Alam, Abdullah G. Al-Sehemi, Gopal Ramalingam. Journal of Molecular Structure Volume 1330, 15 May 2025, 141493.",
        link: "",
        modal: false,
    },
    {
        title: "Anup Basak (2025) Coupled strain-gradient plasticity and incoherent martensitic phase boundary kinetics in isotropic solids: Theory and analytical results. Proceeding of Royal Society A. vol. 481, 20240564.",
        link: "",
        modal: false,
    },
    {
        title: "M.S.V.N Jyoti, S.Gomosta, A.R. Parvathy. S. Baiju, and S.M. Maliyekkal, Wood pulp-derived mesoporous carbon as a reusable substrate for aqueous uranium recovery: Closing the loop by unlocking the nexus between carbon, adsorbed uranium, and energy storage, Chemical Engineering Journal, 505, 2025, 159575.",
        link: "",
        modal: false,
    },
    {
        title: "Shaik, Mujahid, and Balaji Subramanian. 'Computational investigation and validation of new MEXICO experiment.' Wind Engineering (2024): 0309524X241229169.",
        link: "",
        modal: false,
    },
    {
        title: "Reddy, Harshavardhan and Balaji Subramanian. 'Optimum micro-vortex generator design for planar symmetric diffuser under fully developed turbulent flow.' Physics of Fluids 36, no. 12 (2024).",
        link: "",
        modal: false,
    },
    {
        title: "G. Vajitha, K. Jashrapuria, T. P. Gandhi, P. Lipika,  S. P. Singh,  S. M. Maliyekkal, Scalable and cost-effective ultra-dispersible graphene oxide blended ultrafiltration mixed matrix membrane: Assessment of mechanical, water flux, and anti-biofouling properties, Process Safety and Environmental Protection,194, 2025, 35-46.",
        link: "",
        modal: false,
    },
    {
        title: "S.M. Allabakshi, P. Srikar, S. Gomosta, R.K. Gangwar, S.M. Maliyekkal, Treatment of textile dyes in a photo-surface dielectric barrier discharge hybrid reactor: Unraveling the degradation mechanisms, Chemosphere, 368, 2024, 14377.",
        link: "",
        modal: false,
    },
    {
        title: "Sharma, M., Jain, S., 2024. Emission inventory, Air quality, Dispersion modelling, Scenario-based analysis, Carrying capacity of atmosphere. Sustainable Cities and Society, 112, 105650 (IF – 11.7).",
        link: "",
        modal: false,
    },
    {
        title: "Sharma, T., Jain, S., 2023. Nexus between built environment, travel behaviour and human health: An integrated framework to reinform urban system. Journal of Cleaner Production, JCLEPRO-D-22-22515 (IF – 11.1).",
        link: "",
        modal: false,
    },
    {
        title: "M. Aadithya, R. Sunil, S. Gomosta, S.M. Maliyekkal, A.V. Rahul, Behavior of functionalized graphene in fresh and hydrated cement matrix: Role of carboxyl and amine functional group, Construction and Building Materials 450, 2024, 138542.",
        link: "",
        modal: false,
    },
    {
        title: "U. Kannan, G. Pullangott, N. Shraogi, S. Patnaik, S.M. Maliyekkal, Water Disinfection: Unleashing the power of bicarbonate ions in chitosan–silver nanocomposite for greener and more efficient silver utilization, ACS ES&T Water 4(9), 2024, 3842-3850.",
        link: "",
        modal: false,
    },
    {
        title: "P. Srikar, S.M. Allabakshi, S. Gomosta, S.M. Maliyekkal, R.K. Gangwar, Development of efficient nonthermal atmospheric-pressure Ar-plasma jet through simultaneous spectroscopic characterization and radical quantification, Journal of Physics D: Applied Physics 57(39), 2024, 395204.",
        link: "",
        modal: false,
    },
    {
        title: "Pressure-driven transitions in the double perovskite La2CoTiO6: Antiferromagnetic insulator to nonmagnetic metal via antiferromagnetic metal in a double perovskite oxide, Sromona Nandi, Subhadip Pradhan, Ashis K. Nandy, and Rudra Sekhar Manna. Phys. Rev. B 110, 085101, 2024. ",
        link: "https://journals.aps.org/prb/abstract/10.1103/PhysRevB.110.085101",
        modal: false,
    },
    {
        title: "Pressure-induced dimerization and collapse of antiferromagnetism in the Kitaev material   &Alpha;-Li2 IrO3 Bin Shen, Franziska Breitner, Danil Prishchenko, Rudra Sekhar Manna, Anton Jesche, Maximilian L. Seidler, Philipp Gegenwart, and Alexander A. Tsirlin. Phys. Rev. B 105, 054412, 2022.",
        link: "https://journals.aps.org/prb/abstract/10.1103/PhysRevB.105.054412",
        modal: false,
    },

    {
        title: "S. A. A. Balkhi, S. M. Allabakshi, P.S.N.S.R. Srikar, S. Gomosta, R.K. Gangwar, S.M. Maliyekkal, Unwinding the correlation between atmospheric pressure plasma jet operating parameters and variation in antibiotic wastewater characteristics, Journal of Water Process Engineering, 60, 2024, 105186.",
        link: null,
        modal: false,
    },
    {
        title: "M.S.V.N. Jyothi, G. Vajitha, T.P Gandhi, B.J. Ramaiah, S.M. Maliyekkal, Granulated Fe-Mn bimetal-oxides: A reusable adsorbent for mercury removal and valorisation of spent adsorbent as a retarding agent and compressive strength enhancer in cementitious materials, Process Safety and Environmental Protection, 184, 2024, 1293-1305.",
        link: null,
        modal: false,
    },

    {
        title: "T.P.Gandhi, MSVN Jyothi, G.Suman, P.Amesh, S.Manna, S.M.Maliyekkal, A reusable graphene oxide aerogel for preconcentrating and recovering aqueous uranium and valorisation of spent material in a cementitious material, Journal of Cleaner Production, 2023, 140433.",
        link: null,
        modal: false,
    },


    {
        title:
            "S.M.Allabakshi, P.Srikar, S.Gomosta, R.K.Gangwar, S.M.Maliyekkal, Treatment of azo, direct, and reactive dyes in surface dielectric barrier discharge: Valorisation of effluent, the influence of wastewater characteristics, and plasma modeling by stark broadening technique, Journal of Water Process Engineering, 56, 2023, 104503.",
        link: null,
        modal: false,
    },


    {
        title:
            "Irfan, M., Lakshmi, C.N., & Singh, N. (2023).Superhydrophobic polyurethane sponge modified with polydimethylsiloxane / zinc oxide - rGO for efficient oil or organic solvent / water separation.Materials Letters, 134668.",
        link: "https://doi.org/10.1016/j.matlet.2023.134668.",
        modal: false,
    },
    {
        title:
            "Lakshmi, C. N., Irfan, M., Sinha, R., & Singh, N. (2023). Magnetically recoverable Ni-doped iron oxide/graphitic carbon nitride nanocomposites for the improved photocatalytic degradation of ciprofloxacin: Investigation of degradation pathways. Environmental Research, 117812.",
        link: "https://doi.org/10.1016/j.envres.2023.117812.",
        modal: false,
    },
    {
        title:
            "Prabhleen Kukreja and V. Mahendran, “PraaKrum: A Practical Byzantine-Resilient Federated Learning Algorithm”, Accepted in COMSNETS ’24: 16th IEEE International Conference on Communication Systems and Networks, India, January 2024.",
        link: null,
        modal: false,
    },
    {
        title:
            "Bhargav Chandan Palivela, Ravi Sankar Mamilla. Sintering energy conservation in extrusion-based 3D printing of porcelain ceramics blended with copper and allied alloys: A sustainable approach, Ceramic International, 2023, DOI: 10.1016/j.ceramint.2023.10.204",
        link: null,
        modal: false,
    },
    {
        title:
            "Siva Prasad Tadi, Shanmukha Srinivas Maddula, Ravi Sankar Mamilla, Sustainability aspects of composite filament fabrication for 3D printing applications, Renewable and Sustainable Energy Reviews, 2023, DOI: 10.1016/j.rser.2023.113961",
        link: null,
        modal: false,
    },
    {
        title:
            "Biswal, D. and Bahinipati, C.S. Crop-insurance adoption and impact on farm households’ well-being in India: evidence from a panel study. Journal of the Asia Pacific Economy, 2023. DOI: 10.1080/13547860.2023.2266204.",
        link: null,
        modal: false,
    },
    {
        title:
            'Tirumala, Tumula, Ajay Kumar, and Chandra Shekhar Perugu. "Reverse cladding of 304 stainless steel to LM25 aluminium alloy through die-casting." Materials Letters (2023): 134896.',
        link: "https://www.sciencedirect.com/science/article/pii/S0167577X23010819?via%3Dihub",
        modal: false,
    },
    {
        title:
            "Anup Basak (2023) Grain boundary- and triple junction-induced martensitic transformations: A phase-field study of effects of grain boundary width and energy. International Journal of Solids and Structures. doi.org/10.1016/j.ijsolstr.2023.112308.",
        link: "https://www.sciencedirect.com/science/article/pii/S0020768323002056?via%3Dihub",
        modal: false,
    },
    {
        title:
            "Anup Basak, Valery Levitas (2023) A multiphase phase-field study of three-dimensional martensitic twinned microstructures at large strains. Continuum Mechanics and Thermodynamics. doi.org/10.1007/s00161-022-01177-6.",
        link: "https://link.springer.com/article/10.1007/s00161-022-01177-6",
        modal: false,
    },
    {
        title:
            'Shaik, Mujahid, and Balaji Subramanian. "Computational investigation of NREL Phase-VI rotor: Validation of test sequence-S measurements." Wind Engineering (2023):',
        link: "https://journals.sagepub.com/doi/10.1177/0309524X231169298",
        modal: false,
    },
    {
        title:
            "Subhadeep De (IUCAA Pune) and Arijit Sharma (IIT Tirupati), “Indigenisation of the Quantum\r\nClock: An Indispensable Tool for Modern Technologies”, Atoms 2023, 11(4), 71; https://doi.org/10.3390/atoms11040071.",
        link: "https://doi.org/10.3390/atoms11040071.",
        modal: false,
    },
    {
        title:
            "Naresh Babu Kakarla and V. Mahendran, “Lyapunov Meets Thompson: Learning-Based Energy-Efficient UAV Communication with Queuing Stability Constraints”, IEEE INFOCOM DRONECOM Workshop on Drone-Assisted Wireless Communications for 5G and Beyond, New York, USA, May, 2023.",
        link: null,
        modal: false,
    },
    {
        title:
            "Rohit Gupta, V. Mahendran, and B. Venkataramana, “ Optimal Searching of Prefetched DASH Segments in Fog Nodes: A Multi-Armed Bandit Approach”, Proceedings of the 17th ACM Symposium on QoS and Security for Wireless and Mobile Networks, Spain, Nov, 2021.",
        link: null,
        modal: false,
    },
    {
        title:
            "S.M. Allabakshi, P. Srikar, S. Gomosta, R.K. Gangwar, and S.M. Maliyekkal, UV-C photon integrated surface dielectric barrier discharge hybrid reactor: A novel and energy-efficient route for rapid mineralisation of aqueous azo dyes, Journal of Hazardous Materials, 446, 2023, 130639.",
        link: null,
        modal: false,
    },
    {
        title:
            "U. Kannan and S.M. Maliyekkal, A resource-efficient and portable nanotechnology-enabled disinfection system: Performance studies and a novel strategy to recycle spent material, Process Safety and Environmental Protection, 171, 2023, 532-540.",
        link: null,
        modal: false,
    },
    {
        title:
            "Hemant Kumar Singh, Balaji Subramanian, N. Kusuma and S. Harsha. “Parametric optimization and analysis of pressure sensor chip membrane using design of experiments (DOE).” Manufacturing Technology Today (MTT) Journal: National Conference on Micro Systems Technology - 2020. Vol. 19. Issue 9.",
        link: null,
        modal: false,
    },
    {
        title:
            "Reddy, H., & Subramanian, B. (2022). Aerodynamic Design of Three-Dimensional Bellmouth for Low-Speed Open-Circuit Wind Tunnel. International Journal of Aerospace and Mechanical Engineering, 16(10), 241-255.",
        link: null,
        modal: false,
    },
    {
        title:
            "Suresh, G., Bhupatiraju, S. and Sirohi, R.A. Determinants of Women’s Financial Inclusion: Evidence from India, Annals of Public and Cooperative Economics, (Forthcoming)",
        link: null,
        modal: false,
    },
    {
        title:
            "Kothakapa, G. and Sirohi, R.A. ‘Capital as Power’: An Alternative Reading of India’s Post-2011 Economic Slowdown, Area Development and Policy, (Forthcoming)",
        link: null,
        modal: false,
    },
    {
        title:
            "Bahinipati, C. S., Sirohi, R. A., and Rao, S. S. (2022).” Technological Innovations, Behavioural Interventions, and Household Energy Conservation: Policy Insights and Lessons. Ecology, Economy and Society–the INSEE Journal, 5(1), 63-87.",
        link: null,
        modal: false,
    },
    {
        title:
            "Sekhar, N. and Sirohi, RA (2021). The Revolution Will Not Be Colour-blind: The Abiding Relevance of Anti-Apartheid Thought, International Critical Thought, 11(4), 568-584.",
        link: null,
        modal: false,
    },
    {
        title:
            "Kothakapa, G., Bhupatiraju, S and Sirohi, R.A. (2021). Revisiting the Link Between Financial Development and Industrialization: Evidence from Low and Middle Income Countries, Annals of Finance, 17(2), 215-230.",
        link: null,
        modal: false,
    },
    {
        title:
            "Sirohi, RA and Gupta, SS (2020). The Political Economy of Race and Caste: Revisiting the Writings of Mariátegui and Ambedkar, Journal of Labor and Society, 23(3), 399–413.",
        link: null,
        modal: false,
    },
    {
        title:
            "Bahinipati, C.S., and A.K. Gupta, (2022). “Methodological Challenges in Assessing Loss and Damage from Climate-related Extreme Events and Slow Onset Disasters: Evidence from India”, International Journal of Disaster Risk Reduction, Accepted.",
        link: null,
        modal: false,
    },
    {
        title:
            "Paul, B., U. Patnaik, Subash S., K.K. Murari and C.S. Bahinipati, (2022). “Fertilizer use, Value and Knowledge Capital: A case of Indian Farming”, Sustainability, 14(19), 1249.",
        link: null,
        modal: false,
    },
    {
        title:
            "Biswal, D. and C.S. Bahinipati, “Why are farmers not insuring crops against risks in India? A Review”, Progress in Disaster Science, 15: 100241, https://doi.org/10.1016/j.pdisas.2022.100241.",
        link: "https://doi.org/10.1016/j.pdisas.2022.100241.",
        modal: false,
    },
    {
        title:
            "Bahinipati, C.S., R.A. Sirohi and S. Rao, (2022) “Technological innovation and behavioural interventions for household energy conservation: policy insights and lessons”, Ecology, Economy and Society – the INSEE Journal, 5(1), 63-87.",
        link: null,
        modal: false,
    },
    {
        title:
            "Bahinipati, C.S. and U. Patnaik, (2022), “What motivates farm-level adaptation in India? A systematic review”, In Haque, A.K.E. et al., ‘Climate change and community resilience: insights from South Asia’, Springer, Chapter 4, pp. 49.68.",
        link: null,
        modal: false,
    },
    {
        title:
            "Bahinipati, C.S., V. Kumar and P.K. Viswanathan, (2021) “An Evidence based systematic review on farmers’ adaptation strategies in India”, Food Security, 13(2): 399-418.",
        link: null,
        modal: false,
    },
    {
        title:
            "Loganathan, S., C.S. Bahinipati, K.E. Seetharam and K.N. Satyanarayana, (2021), “Policies and priorities for developing capacity to build high quality infrastructure”, In Hayashi, Y. et al., ‘Frontiers in high-speed rail development’, ADBI Press, Tokyo, Chapter 20, pp. 510-525.",
        link: null,
        modal: false,
    },
    {
        title:
            "Bahinipati, C.S., and U. Patnaik, (2020), “Does development reduce damage risk from climate extremes? Empirical evidence for floods in India”, Water Policy, 22(5), 748-767.",
        link: null,
        modal: false,
    },
    {
        title:
            "Boyalakuntla, K., Marimuthu, C., Chimalakonda, S., Chandrasekaran, K. (November, 2022). “eGEN: An Energy-saving Modeling Language and Code Generator for Location-sensing of Mobile Apps.” In Proceedings of 2022 ACM Joint European Software Engineering Conference and Symposium on the Foundations of Software Engineering (ESEC/FSE 2022), Singapore (to appear)",
        link: null,
        modal: false,
    },
    {
        title:
            "Shanbhag, S., Chimalakonda, S. (November, 2022). “Exploring the Underexplored Terrain of Non-Open Source Data for Software Engineering through the Lens of Federated Learning.” In Proceedings of 2022 ACM Joint European Software Engineering Conference and Symposium on the Foundations of Software Engineering (ESEC/FSE 2022), Singapore (to appear)",
        link: null,
        modal: false,
    },
    {
        title:
            "Shanbhag, S., Chimalakonda, S., Sharma, V. S., & Kaulgud, V. (October, 2022). “eTagger - An Energy Pattern Tagging Tool for GitHub Issues in Android Projects..” In Proceedings of the 38th IEEE International Conference on Software Maintenance and Evolution (ICSME), Cyprus. (to appear)",
        link: null,
        modal: false,
    },
    {
        title:
            "Ali, S., Manjunath, N., Chimalakonda, S. (October, 2022). “COBREX: A Tool for Extracting Business Rules from COBOL.” In Proceedings of the 38th IEEE International Conference on Software Maintenance and Evolution (ICSME), Cyprus. (to appear)",
        link: null,
        modal: false,
    },
    {
        title:
            "Eashaan Rao, A., & Chimalakonda, S. (October, 2022). “Apples, Oranges & Fruits - Understanding Similarity of Software Repositories Through The Lens of Dissimilar Artifacts.”, In Proceedings of the 38th IEEE International Conference on Software Maintenance and Evolution (ICSME), Cyprus. (to appear)",
        link: null,
        modal: false,
    },
    {
        title:
            "Boyalakuntla, K., Nagappan, M., Chimalakonda, S.  & Munaiah, N. (October, 2022). “RepoQuester: A Tool Towards Evaluating GitHub Projects”, In Proceedings of 38th IEEE International Conference on Software Maintenance and Evolution (ICSME), Cyprus. (to appear)",
        link: null,
        modal: false,
    },
    {
        title:
            "Sarma, P., Chimalakonda, S. (November, 2022). “API + Code = Better Code Summary? - Insights from an Exploratory Study.” In Proceedings of the 18th International Conference on Predictive Models and Data Analytics in Software Engineering  (PROMISE), Singapore (to appear).",
        link: null,
        modal: false,
    },
    {
        title:
            'Narayana Teja Ayyadevara,  Balaji Subramanian and  Naga Suresh Meda, "Experimental and Computational Investigation for Accelerated Testing and Characterization of Next-generation Steam Turbine Rotors," Journal of Thermal Science and Engineering Applications(2022): 1-16.',
        link: null,
        modal: false,
    },
    {
        title:
            "S. M. Allabakshi, P.S. N. S. R. Srikar, R. K. Gangwar, and S. M. Maliyekkal. “Feasibility of surface dielectric barrier discharge in wastewater treatment: Spectroscopic modeling, diagnostic, and dye mineralization”, Separation and Purification Technology, Elsevier, vol. 296, 2022, pp. 121344.",
        link: null,
        modal: false,
    },
    {
        title:
            "A. Harafan, R.K. Gangwar, and S.M. Maliyekkal. “Abatement of pesticides in drinking water by nanoscale carbon materials,” Separation Science and Technology, Elsevier, vol. 15, 2022, pp. 139-161.",
        link: null,
        modal: false,
    },
    {
        title:
            "M Monachan, N Dixit, SM Maliyekkal, and S P Singh, “Reverse Osmosis (RO) and Nanofiltration (NF) membranes for emerging contaminants (ECs) removal, New Trends in Emerging Environmental Contaminants”, Springer, 2022, pp. 407-425.",
        link: null,
        modal: false,
    },
    {
        title:
            "Kumarswamyreddy, N.; Reddy, D. N.; Robkis, D. M.; Kamiya, N.; Tsukamoto, R.; Kanaoka, M. M.; Higashiyama, T.; Oishi, S.; Bode, J. W.; “Chemical Synthesis of Torenia Plant Pollen Tube Attractant Proteins by KAHA Ligation”. RSC Chem. Biol. 2022, accepted.",
        link: "https://doi.org/10.1039/D2CB00039C",
        modal: false,
    },
    {
        title:
            'Muthusamy, S.; Kumarswamyreddy, N*.; Kesavan, V.; "Enantioselective Synthesis of 3-Amino-3’-carbazole Oxindole Derivatives via Friedel-Crafts Aminoalkylation Reaction". ChemistrySelect, 2022, 7, e202200131 (*Corresponding Author).',
        link: "https://doi.org/10.1002/slct.202200131",
        modal: false,
    },
    {
        title:
            "K. Boya, K. Nam, A. K. Manna, J. Kang, C. Lyi, A. Jain, S. M. Yusuf, P. Khuntia, B. Sana, V. Kumar, A. V. Mahajan, Deepak R. Patil, Kee Hoon Kim, S. K. Panda, B. Koteswararao, Magnetic properties of the S=5/2 anisotropic triangular chain compound Bi3FeMo2O12, Physical Review B 104, 184402 (2021).",
        link: null,
        modal: false,
    },
    {
        title:
            "U. K. Voma, S. Bhattacharya, E. Kermarrec, J. Alam, Y. M. Jana, B. Sana, P. Khuntia, S. K. Panda, B. Koteswararao, Electronic structure and magnetic properties of the effective spin J eff =1/2 two-dimensional triangular lattice K3Yb(VO4)2, Physical Review B 104, 144411 (2021).",
        link: null,
        modal: false,
    },
    {
        title:
            "E. Kermarrec, R. Kumar, G. Bernard, R. Hénaff, P. Mendels, F. Bert, P. L. Paulose, B. K. Hazra, B. Koteswararao, Classical Spin Liquid State in the Heisenberg Kagome Antiferromagnet Li9Fe3(P2O7)3(PO4)2, Physical review letters 127, 157202 (2021).",
        link: null,
        modal: false,
    },
    {
        title:
            "Venigalla, A. S. M., Vagavolu, D., & Chimalakonda, S. (2022, January). SurviveCovid-19-an educational game to facilitate habituation of social distancing and other health measures for covid-19 pandemic. International Journal of Human–Computer Interaction, 1-13.",
        link: null,
        modal: false,
    },
    {
        title:
            "Agrahari, V., & Chimalakonda, S. (2022, February). A Catalogue of Game-Specific Anti-Patterns. In 15th Innovations in Software Engineering Conference (pp. 1-10).",
        link: null,
        modal: false,
    },
    {
        title:
            "Gupta, N., Rajput, A., & Chimalakonda, S. (2022, May). COSPEX: A Program Comprehension Tool for Novice Programmers. To Appear In 2022 IEEE/ACM 44th International Conference on Software Engineering: Companion Proceedings (ICSE-Companion).",
        link: null,
        modal: false,
    },
    {
        title:
            "Venigalla, A. S. M., Boyalakunta, K., & Chimalakonda, S. (2022, May). GitQ-Towards Using Badges as Visual Cues for GitHub Projects. To Appear in Proceedings of 2022 IEEE/ACM 30th International Conference on Program Comprehension (ICPC).",
        link: null,
        modal: false,
    },
    {
        title:
            "Shanbagh, S., Chimalakonda, S., Sharma, V. S., & Kaulgud, V. (2022, June). Towards a Catalog of Energy Patterns in Deep Learning Development. To Appear In Proceedings of the Evaluation and Assessment in Software Engineering (EASE).",
        link: null,
        modal: false,
    },
    {
        title:
            "Das, D., Mathews, N. S., & Chimalakonda, S. (2022, June). Exploring Security Vulnerabilities in Competitive Programming: An Empirical Study. To Appear In Proceedings of the Evaluation and Assessment in Software Engineering (EASE).",
        link: null,
        modal: false,
    },
    {
        title:
            "T.P. Gandhi, P. V. Sampath, S. M. Maliyekkal, A critical review of uranium contamination in groundwater: Treatment and sludge disposal, Science of The Total Environment, 2022, 15394.",
        link: "https://doi.org/10.1016/j.scitotenv.2022.153947.",
        modal: false,
    },
    {
        title:
            "M.S.V.N. Jyothi, A Harafan, S.S. Gupta, N. Neethu, G. Singhal, B.J. Ramaiah, S.M. Maliyekkal, Chitosan immobilised granular FeOOH-MnxOy bimetal-oxides nanocomposite for the adsorptive removal of lead from water, Journal of Environmental Chemical Engineering, 10(2), 2022, 107353.",
        link: "https://doi.org/10.1016/j.jece.2022.107353.",
        modal: false,
    },
    {
        title:
            "U. Kannan, S.A. Gafoor, S. Srivastava, S. Gupta, M. Nithyaharan, S.M. Maliyekkal, A waste-derived nanocomposite sealant for repairing micro-cracks in concrete, Journal of Building Engineering, 48(1), 2022, 103965.",
        link: "https://doi.org/10.1016/j.jobe.2021.103965.",
        modal: false,
    },
    {
        title:
            "New Trends in Emerging Environmental Contaminants, 2022. Editors: S P Singh, T Gupta, AK Agarwal, SM Maliyekkal.  Print ISBN: 978-981-16-8366-4; Electronic ISBN: 978-981-16-8367.",
        link: null,
        modal: false,
    },
    {
        title:
            "S. M. Allabakshi, P.S.N.S.R. Srikar; R. Gangwar, S.M. Maliyekkal “Application of plasma-assisted advanced oxidation processes for removal of emerging contaminants in water”, New Trends in Emerging Environmental Contaminants, Springer, 333-370, 2022. DOI: 10.1007/978-981-16-8367-1_15.",
        link: null,
        modal: false,
    },
    {
        title:
            "A. Harafan, S.A. Gafoor, T. D. Kusuma, S. M Maliyekkal, “Graphene modified photocatalysts for the abatement of emerging contaminants in water”, New Trends in Emerging Environmental Contaminants, Springer, 371-406, 2022, Springer. DOI: httpp://doi.org/ 10.1007/978-981-16-8367-1_16.",
        link: "httpp://doi.org/ 10.1007/978-981-16-8367-1_16.",
        modal: false,
    },
    {
        title:
            "T.D. Kusuma, M.S.V.N. Jyothi, C.P. Rao, S.M. Maliyekkal, “Advanced Oxidation Processes: A Promising Route for Abatement of Emerging Contaminants in Water”, In: Nanomaterials and Nanocomposites for Environmental Remediation, Springer, 275-305, 2021. DOI: 10.1007/978-981-16-3256-3_12.",
        link: null,
        modal: false,
    },
    {
        title:
            "M. S. V. N. Jyothi, S., Gayathri. S, T. P. Gandhi, S.M. Maliyekkal, “Dissolved arsenic in groundwater bodies: A short review of remediation technologies”, Pollution Control Technologies: Current Status and Future Prospects, Springer, 75-111, 2021. DOI: 10.1007/978-981-16-0858-2_5.",
        link: null,
        modal: false,
    },
    {
        title:
            "Rajan, G. K., Damping rate measurements and predictions for gravity waves in an air-oil-water system, Phys. Fluids, Vol. 34(2), p. 022113, 2022. Link:https://doi.org/10.1063/5.0078160 ",
        link: "https://doi.org/10.1063/5.0078160",
        modal: false,
    },
    {
        title:
            "Jain, S., Sharma, T., Gupta, AK., 2022. End-of-life management of solar PV waste in India: Situation analysis and policy framework. Renewable & Sustainable Energy Reviews, 153:111774.",
        link: null,
        modal: false,
    },
    {
        title:
            "Barthwal, V., Jain, S., Babuta, A., Jamir, C., Sharma, AK., Mohan, A., 2022. Health impact assessment of Delhi’s outdoor workers exposed to air pollution and extreme weather events: An integrated epidemiology approach. Journal of Environmental Science and Pollution Research DOI:10.1007/s11356-022-18886-9.",
        link: null,
        modal: false,
    },
    {
        title:
            "Jain, S., Barthwal, V., 2022. Health impact assessment of auto rickshaw and cab drivers due to exposure to vehicular pollution in Delhi: An integrated approach. Journal of Environmental Science and Pollution Research 29:5124–5133.",
        link: null,
        modal: false,
    },
    {
        title:
            "Dwivedi, P. S. (Editor). Aesthetics and the Philosophy of Art: Comparative Perspectives, Routledge India, 2021. https://doi.org/10.4324/9781003094401",
        link: "https://doi.org/10.4324/9781003094401",
        modal: false,
    },
    {
        title:
            'Dwivedi, P. S. "Exploring Ethics and Aesthetics of Eco-Caring in Uttararāmacarita". Journal of Dharma, 46(2), June 2021, 129-144.\r\n\r\nhttp://dvkjournals.in/index.php/jd/article/view/3428',
        link: "http://dvkjournals.in/index.php/jd/article/view/3428",
        modal: false,
    },
    {
        title:
            'Dwivedi, P. S. "Karaha Pujan: A Folk-Worship of Krsna in Eastern Uttar Pradesh". Religions of South Asia, 13(2), February 2021, 160–187. https://doi.org/10.1558/rosa.19309',
        link: "https://doi.org/10.1558/rosa.19309",
        modal: false,
    },
    {
        title:
            "Nikhil Kumar Etteneni and Madan Mohan Avulapati, An Experimental Investigation on Liquid Sheet Breakup due to Perforations in Impinging Jet Atomization, Atomization and Sprays (2021), \r\nDOI: 10.1615/AtomizSpr.2021037826",
        link: null,
        modal: false,
    },
    {
        title:
            "Prasad Boggavarapu, Surya Prakash Ramesh, Madan Mohan Avulapati, Ravikrishna RV,  Secondary Breakup of Water and Surrogate fuels: Breakup Modes and Resultant Droplet Sizes, International Journal of Multiphase Flow 145 (2021) 103816.",
        link: null,
        modal: false,
    },
    {
        title:
            'Kumarswamyreddy, N*.;Jayakumar, S.; Kesavan, V.; "Palladium-catalyzed Asymmetric Allylic Alkylation of 3-Amino-2-Oxindoles: Synthesis of 3-Allyl-3-Amino-2-Oxindoles". Tetrahedron Lett., 2021, in press (*Corresponding Author). https://doi.org/10.1016/j.tetlet.2021.153385.',
        link: "https://doi.org/10.1016/j.tetlet.2021.153385.",
        modal: false,
    },
    {
        title:
            'Pratap Reddy Gajulapalli, V.; Kumarswamyreddy, N*.; Lokesh, K.; Kesavan, V.; "Enantioselective Synthesis of 3-Acetyl Coumarin Substituted 3-Hydroxy Oxindoles and Pyranocoumarin Fused Spirooxindoles". ChemistrySelect., 2021, 6 (31), 7855-7859 (*Corresponding Author). https://doi.org/10.1002/slct.202102495.',
        link: "https://doi.org/10.1002/slct.202102495.",
        modal: false,
    },
    {
        title:
            "M. Besta, R. Kanakagiri, G. Kwasniewski, R. Ausavarungnirun, J. Beránek, K. Kanellopoulos, K. Janda, Z. Vonarburg-Shmaria, L. Gianinazzi, I. Stefan, J. Gómez-Luna, N. Blach, M. Copik, L. Kapp-Schwoerer, S. Di Girolamo, M. Konieczny, O. Mutlu, T. Hoefler. “SISA: Set-Centric Instruction Set Architecture for Graph Mining on Processing-in-Memory Systems”, Proceedings of the 54th IEEE/ACM International Symposium on Microarchitecture (MICRO), 2021.",
        link: null,
        modal: false,
    },
    {
        title:
            "Vagavolu, D., Swarna, K. C., & Chimalakonda, S. (2021). A Mocktail of Source Code Representations.  To Appear In Proceedings of the 36th IEEE/ACM International Conference on Automated Software Engineering.",
        link: null,
        modal: false,
    },
    {
        title:
            "Josfel Flora John, Mohanraj Jagannathan, Ajay Rakkesh Rajendran, Panneerselvam Mohanapriya, Tirupattur  Srinivasan Natarajan, Durgalakshmi Dhinasekaran, (2021) Sustainable multilayer biomass carbon and polymer hybrid column as potential antibacterial water filter, Chemosphere, 286, 131691. https://doi.org/10.1016/j.chemosphere.2021.131691",
        link: "https://doi.org/10.1016/j.chemosphere.2021.131691",
        modal: false,
    },
    {
        title:
            "Raihana, M. K., Padmanathan, N., Eswaramoorthi, V., David McNulty, Jhelai Sahadevan, Mohanapriya, P., Esakki Muthu, S., (2021) Reduced Graphene Oxide/VSB-5 Composite Micro/Nanorod Electrode for High Energy Density Supercapattery,  Electrochimica Acta,  391, 138903.https://doi.org/10.1016/j.electacta.2021.138903",
        link: "https://doi.org/10.1016/j.electacta.2021.138903",
        modal: false,
    },
    {
        title:
            "Rekha Pachaiappan, Saravanan Rajendran, Gomathi Ramalingam, Dai-Viet N. Vo,Mohanapriya, P., Matias Soto-Moscoso, (2021)  Green Synthesis of Zinc Oxide Nanoparticles by Justicia adhatoda Leaves and Their Antimicrobial Activity, Chem. Eng. Technol., 44,No. 3, 1–9. https://doi.org/10.1002/ceat.202000470",
        link: "https://doi.org/10.1002/ceat.202000470",
        modal: false,
    },
    {
        title:
            "Arjun Kumar, B., Kumar, P., Elangovan, T., Ramalingam, G., Ravi, G., Mohanapriya, P., Natarajan, T. S., (2021) Surface functionalization of core-shell QDs for solar photovoltaic and anti-cancer applications, Applied Surface Science Advances, 5,  100122. https://doi.org/10.1016/j.apsadv.2021.100122",
        link: "https://doi.org/10.1016/j.apsadv.2021.100122",
        modal: false,
    },
    {
        title:
            'Venigalla, A. S. M., Vagavolu, D., & Chimalakonda, S. (2021). "SurviveCovid-19++ : A collaborative healthcare game towards educating people about safety measures for Covid-19", To Appear In Proceedings of the 24th ACM Conference on Computer-Supported Cooperative Work and Social Computing (CSCW) 2021.',
        link: null,
        modal: false,
    },
    {
        title:
            "Mathews, N. S., Chimalakonda, S., & Jain, S. (2021). “AiR- An Augmented Reality Application for Visualizing Air Pollution”, To Appear In Proceedings of IEEE VIS 2021.",
        link: null,
        modal: false,
    },
    {
        title:
            'Venigalla, A. S. M., & Chimalakonda, S. (2021). "StackEmo - Towards Enhancing User Experience by Augmenting Stack Overflow with Emojis", To Appear In Proceedings of the 29th ACM Joint Meeting on European Software Engineering Conference and Symposium on the Foundations of Software Engineering (ESEC/FSE) 2021.',
        link: null,
        modal: false,
    },
    {
        title:
            "Eashaan Rao, A., Vagavolu, D., & Chimalakonda, S.  “AC2--Towards Understanding Architectural Changes in Rapid Releases”, To Appear In Proceedings of the 29th ACM Joint Meeting on European Software Engineering Conference and Symposium on the Foundations of Software Engineering (ESEC/FSE) 2021.",
        link: null,
        modal: false,
    },
    {
        title:
            "Venigalla, ASM, Chimalakonda, S. On the comprehension of application programming interface usability in game engines. Softw Pract Exper. 2021; 51: 1728– 1744.",
        link: "https://doi.org/10.1002/spe.2985",
        modal: false,
    },
    {
        title:
            "Anup Basak (2021) Grain boundary-induced premelting and solid↔melt phase transformations: Effect of interfacial widths and energies and triple junctions at nanoscale. Physical Chemistry Chemical Physics (to appear).",
        link: null,
        modal: false,
    },
    {
        title:
            "Aviru Kumar Basu, Anup Basak, Shantanu Bhattacharya (2020) Geometry and thickness dependant anomalous mechanical behavior of fabricated SU-8 thin film micro-cantilevers. Journal of Micromanufacturing, vol. 2, pp- 113-120 (doi.org/10.1177/2516598420930988)",
        link: "https://doi.org/10.1177/2516598420930988",
        modal: false,
    },
    {
        title:
            "Rajan, G. K., Solutions of a comprehensive dispersion relation for waves at the elastic interface of two viscous fluids, European Journal of Mechanics / B Fluids, Vol. 89C (2021), pp. 241-258, 2021, Link: https://doi.org/10.1016/j.euromechflu.2021.05.012",
        link: "https://doi.org/10.1016/j.euromechflu.2021.05.012",
        modal: false,
    },
    {
        title:
            "Ajay Kumar et al., Sand casting of surface alloyed butterfly valve with improved hardness and corrosion resistance by incorporating metal powders in-mold coatings. International Journal of Metalcasting 2021. https://doi.org/10.1007/s40962-021-00609-4",
        link: "https://doi.org/10.1007/s40962-021-00609-4",
        modal: false,
    },
    {
        title:
            'Kumar Rohit, BN Ravi Srivatsa, and Balaji Subramanian "Calibration design evaluations through computational analysis and investigation of a six-component wind tunnel balance." ISSS Journal of Micro and Smart Systems (2021): 1-25.',
        link: null,
        modal: false,
    },
    {
        title:
            "Chockalingam, S.N., Pandurangan, V. and Nithyadharan, M. (2021), Timoshenko beam formulation for in-plane behaviour of tapered monosymmetric I-beams: Analytical solution and exact stiffness matrix, Thin-walled Structures, Volume 162, 107604.",
        link: null,
        modal: false,
    },
    {
        title:
            "Nithyadharan, M. and Kalyanaraman, V. (2021), A new screw connection model and FEA of CFS shear wall panels, Journal of Constructional Steel Research, Volume 176, 106430.",
        link: null,
        modal: false,
    },
    {
        title:
            "Chockalingam, S.N., Nithyadharan, M. and Pandurangan, V.  (2020), Shear stress distribution in tapered I-beams: Analytical expression and finite element validation, Thin-walled Structures, Volume 157, 107152.",
        link: null,
        modal: false,
    },
    {
        title:
            "Chimalakonda, S. & Hyung Lee, D. A Family of Standards for Software and Systems Product Lines, Computer Standards & Interfaces, 2021, 103537. https://doi.org/10.1016/j.csi.2021.103537.",
        link: "https://doi.org/10.1016/j.csi.2021.103537.",
        modal: false,
    },
    {
        title:
            "Vagavolu, D., Agrahari, V., Chimalakonda, S., & Venigalla, A. S. M., GE526: A Dataset of Open Source Game Engines, To Appear In Proceedings of the 2021 IEEE/ACM 18th International Conference on Mining Software Repositories (MSR).",
        link: null,
        modal: false,
    },
    {
        title:
            "G. Pullangott, U., Kannan, S. Gayathri, D.V. Kiran, S.M. Maliyekkal, A comprehensive review on antimicrobial face masks: an emerging weapon in fighting pandemics, RSC Advances 11 (12), 6544-6576.",
        link: null,
        modal: false,
    },
    {
        title:
            "Madan Mohan Avulapati, Radboud Pos, Thanos Megaritis, Lionel Ganippa, Insights into near nozzle spray evolution, ignition and air/flame entrainment in high pressure spray flames,Fuel, Volume 293, 2021,120383. DOI: https://doi.org/10.1016/j.fuel.2021.120383.",
        link: "https://doi.org/10.1016/j.fuel.2021.120383.",
        modal: false,
    },
    {
        title:
            "Oscar A. de la Garza, S. Martínez-Martínez, Madan Mohan Avulapati, Radboud Pos, Thanos Megaritis, Lionel Ganippa,\r\nBiofuels and its spray interactions under pilot-main injection strategy,\r\nEnergy, Volume 219, 2021, 119464. DOI:https://doi.org/10.1016/j.energy.2020.119464.",
        link: "https://doi.org/10.1016/j.energy.2020.119464.",
        modal: false,
    },
    {
        title:
            'Bhaskara S. Egala, Ashok K. Pradhan, Venkataramana Badarla, and Saraju P. Mohanty, "Fortified-Chain: A Blockchain Based Framework for Security and Privacy Assured Internet of Medical Things with Effective Access Control",  IEEE Internet of Things Journal (accepted), February 2021.',
        link: null,
        modal: false,
    },
    {
        title:
            "Fabrication and applications of fullerene-based metal nanocomposites: A review Ajay Kumar P., Vishnu Namboodiri V., Gaurang Joshi & Kush P. Mehta Journal of Materials Research (2021) DOI : https://doi.org/10.1557/s43578-020-00094-1.",
        link: "https://doi.org/10.1557/s43578-020-00094-1.",
        modal: false,
    },
    {
        title:
            'Agrahari, V., & Chimalakonda, S.,"What\'s inside Unreal Engine - A Curious Gaze!." To Appear in Proceedings of the 14th Innovations in Software Engineering Conference  (Formerly known as India Software Engineering Conference), 2021.',
        link: null,
        modal: false,
    },
    {
        title:
            'Venigalla, A. S. M., & Chimalakonda, S., "Understanding Emotions of Developer Community Towards Software Documentation." To Appear In Proceedings of the IEEE/ACM 43rd International Conference on Software Engineering: Software Engineering in Society (ICSE-SEIS), 2021.',
        link: null,
        modal: false,
    },
    {
        title:
            'Vadlamani, A., Kalicheti, R., & Chimalakonda, S., "APIScanner - Towards Automated Detection of Deprecated APIs in Python Libraries", To Appear In Proceedings of the IEEE/ACM 43rd International Conference on Software Engineering (ICSE), 2021.',
        link: null,
        modal: false,
    },
    {
        title:
            "Poonam Wagh.; Jency M. Sojan; Sriram Babu.; Valsala, R.; Bhatia, S.; Roshan Srivastav. Indicative Lake Water Quality Assessment Using Remote Sensing Images-Effect of COVID-19 Lockdown. Water 2021, 13, 73.  https://doi.org/10.3390/w13010073",
        link: "https://doi.org/10.3390/w13010073",
        modal: false,
    },
    {
        title:
            "Rajan, G. K., A three-fluid model for the dissipation of interfacial capillary-gravity waves, Phys. Fluids, Vol. 32(12), p. 122121, 2020.  DOI: 10.1063/5.0030812.",
        link: null,
        modal: false,
    },
    {
        title:
            'Ravi Sharma and Venkataramana Badarla, "A Multi Objective Optimization Tool-Chain for 3D Indoor Beacon Placement Problem",  IEEE Internet of Things Journal (accepted), October 2020.',
        link: null,
        modal: false,
    },
    {
        title:
            'Prabu, SS Mani, Chandra S. Perugu, Ashutosh Jangde, H. C. Madhu, M. Manikandan, Manoj D. Joshi, Santosh S. Hosmani, Ajay Kumar, Satish V. Kailas, and I. A. Palani. "Investigations on the influence of surface mechanical attrition treatment on the corrosion behaviour of friction stir welded NiTi shape memory alloy." Surface and Coatings Technology (2020): 126495.  \r\nLink: https://doi.org/10.1016/j.surfcoat.2020.126495',
        link: "https://doi.org/10.1016/j.surfcoat.2020.126495",
        modal: false,
    },
    {
        title:
            "Raj, P., Asaithambi, G. and Ravi Shankar, A. U. (2020). Effect of Curbside Bus Stops on Passenger Car Units and Capacity in Disordered Traffic using Simulation Model. Transportation Letters, DOI: 10.1080/19427867.2020.1815145",
        link: "https://www.tandfonline.com/doi/full/10.1080/19427867.2020.1815145",
        modal: false,
    },
    {
        title:
            "Madhuri Kashyap N. R., Chilukuri, B.R., Srinivasan, K.K., and Asaithambi, G. (2020). Analysis of Vehicle-Following Behavior in Mixed Traffic Conditions using Vehicle Trajectory Data. Transportation Research Record, Transportation Research Board, USA.",
        link: null,
        modal: false,
    },
    {
        title:
            "U. Kannan, P.C. Sabumon, S. M. Maliyekkal, Development of an eco-friendly and reusable point-of-use disinfection system, Process Safety and Environmental Protection, 2021, 148, 104-113.",
        link: null,
        modal: false,
    },
    {
        title:
            "S. Desireddy, P.C. Sabumon, S.M. Maliyekkal, Anoxic ammonia removal using granulated nanostructured Fe oxyhydroxides and the effect of pH, temperature and potential inhibitors on the process, Journal of Water Process Engineering, 33, 10106, 2020.",
        link: null,
        modal: false,
    },
    {
        title:
            'Venigalla, Akhila Sri Manasa, and Sridhar Chimalakonda. "EmoG- Towards Emojifying Gmail Conversations." To Appear In Proceedings of the 54th Hawaii International Conference on System Sciences. 2021.',
        link: null,
        modal: false,
    },
    {
        title:
            "Marimuthu, C.,  Chimalakonda, S., & Chandrasekaran, K. (2020). How Do Open Source App Developers Perceive API Changes related to Android Battery Optimization? An Empirical Study. To Appear in Software: Practice and Experience journal.",
        link: null,
        modal: false,
    },
    {
        title:
            "Chimalakonda, S., & Venigalla, A. S. M. (2020, November). Software Documentation and Augmented Reality: Love or Arranged Marriage?. To Appear In Proceedings of the 2020 28th ACM Joint Meeting on European Software Engineering Conference and Symposium on the Foundations of Software Engineering.",
        link: null,
        modal: false,
    },
    {
        title:
            "Mathews, N. S., Chimalakonda, S, Venigalla, A. S. M. (2020, October). YTCoder - Towards Turning YouTube into a Development Environment. To Appear In Conference Companion Publication of the 2020 on Computer Supported Cooperative Work and Social Computing.",
        link: null,
        modal: false,
    },
    {
        title:
            "Venigalla, A. S. M., Chimalakonda, S,  Vagavolu, D. (2020, October). Mood of India During Covid-19 - An Interactive Web Portal Based on Emotion Analysis of Twitter Data. To Appear In Conference Companion Publication of the 2020 on Computer Supported Cooperative Work and Social Computing.",
        link: null,
        modal: false,
    },
    {
        title:
            "Venigalla, A. S. M., & Chimalakonda, S. (2020). G4D-a treasure hunt game for novice programmers to learn debugging. Smart Learning Environments, 7(1), 1-21.",
        link: null,
        modal: false,
    },
    {
        title:
            "Chimalakonda, S., & Nori, K. V. (2020).  An ontology based modeling framework for design of educational technologies. To Appear in Smart Learning Environments journal.",
        link: null,
        modal: false,
    },
    {
        title:
            "Marimuthu, C., Chandrasekaran, K., & Chimalakonda, S. (2020). Energy Diagnosis of Android Applications: A Thematic Taxonomy and Survey. To Appear in ACM Computing Surveys (CSUR) journal.",
        link: null,
        modal: false,
    },
    {
        title:
            "Tushar Joshi, Rajat Arora, Anup Basak, Anurag Gupta (2020) Equilibrium shape of misfitting precipitates with anisotropic elasticity and anisotropic interfacial energy. Modeling and Simulation in Materials Science and Engineering. doi.org/10.1088/1361-651X/abae12.",
        link: "https://iopscience.iop.org/article/10.1088/1361-651X/abae12",
        modal: false,
    },
    {
        title:
            'Joe Augustine, Raghavendra Kanakagiri, John Jose, Madhu Mutyam, "Router Buffer Caching for Managing Shared Cache Blocks in Tiled Multi-Core Processors" (to appear) in IEEE International Conference on Computer Design (ICCD), 2020.',
        link: null,
        modal: false,
    },
    {
        title:
            'Maciej Besta*, Raghavendra Kanakagiri*, Harun Mustafa, Mikhail Karasikov, Gunnar Rätsch, Torsten Hoefler, Edgar Solomonik, "Communication-Efficient Jaccard Similarity for High-Performance Distributed Genome Comparisons" (*Equal contribution) in IEEE International Parallel & Distributed Processing Symposium (IPDPS), 2020.',
        link: null,
        modal: false,
    },
    {
        title:
            "Rajan, G. K, Dissipation of interfacial Marangoni waves and their resonance with capillary-gravity waves, International Journal of Engineering Science, Vol. 154, 103340, 2020. Link:https://doi.org/10.1016/j.ijengsci.2020.103340",
        link: "https://doi.org/10.1016/j.ijengsci.2020.103340",
        modal: false,
    },
    {
        title:
            "Rohatgi, P.K., Ajay Kumar, P., Chelliah, N.M. et al. Solidification Processing of Cast Metal Matrix Composites Over the Last 50 Years and Opportunities for the Future. JOM (2020). DOI : https://doi.org/10.1007/s11837-020-04253-x.",
        link: "https://doi.org/10.1007/s11837-020-04253-x.",
        modal: false,
    },
    {
        title:
            "Arora, P., Sharma, D., Kumar, P., Jain, S., 2020. Assessment of clean cooking technologies under different fuel use conditions in rural areas of Northern India. Chemosphere, 257:127315.",
        link: null,
        modal: false,
    },
    {
        title:
            "Jain, S., Sharma, T., 2020. Social and Travel Lockdown Impact Considering Coronavirus Disease (COVID-19) on Air Quality in Megacities of India: Present Benefits, Future Challenges and Way Forward. Aerosol and Air Quality Research, 20:1222–1236.",
        link: null,
        modal: false,
    },
    {
        title:
            "Bhatia, N.; Jency M. Sojan.; Simonovic, S.; Roshan Srivastav. Role of Cluster Validity Indices in Delineation of Precipitation Regions. Water 2020, 12, 1372. https://doi.org/10.3390/w12051372",
        link: "https://doi.org/10.3390/w12051372",
        modal: false,
    },
    {
        title:
            "Venigalla, A. S. M., & Chimalakonda, S. (2020). DynamiQue– A Technical Intervention To Augment Static Textbook with Dynamic Q&A. Interactive Learning Environments, 1-15.",
        link: null,
        modal: false,
    },
    {
        title:
            "Agrahari, V., & Chimalakonda, S. (2020). Refactor4Green: A Game for Novice Programmers to Learn Code Smells. To Appear In Proceedings of IEEE/ACM 42nd International Conference on Software Engineering (ICSE), Korea, 2020",
        link: null,
        modal: false,
    },
    {
        title:
            "Rao, A.E., & Chimalakonda, S. (2020, April). An Exploratory Study Towards Understanding Lambda Expressions in Python. To Appear In Proceedings of the 24th International Conference on Evaluation and Assessment in Software Engineering (EASE), 15-17 April 2020, Trondheim, Norway, 2020.",
        link: null,
        modal: false,
    },
    {
        title:
            "Agrahari, V., & Chimalakonda, S. (2020, July). AST[AR] - Towards Using Augmented Reality for Teaching Abstract Syntax Trees To Novice Programmers. To Appear In IEEE 20th International Conference on Advanced Learning Technologies (ICALT), 6 - 9 July · Tartu,\r\nEstonia, 2020",
        link: null,
        modal: false,
    },
    {
        title:
            "Agrahari, V., & Chimalakonda, S. (2020, July). L2- A Mini Game for Learning Indian Language Vocabulary. To Appear In IEEE 20th International Conference on Advanced Learning Technologies (ICALT), 6 - 9 July · Tartu, Estonia, 2020",
        link: null,
        modal: false,
    },
    {
        title:
            "Agrahari, V., & Chimalakonda, S. (2020, July). SupportArr: A Plugin to Comprehend Arrays for Novice Programmers. To Appear In IEEE 20th International Conference on Advanced Learning Technologies (ICALT), 6 - 9 July · Tartu, Estonia, 2020",
        link: null,
        modal: false,
    },
    {
        title:
            "P. Pramanik, D. C. Joshi, M. Reehuis, A. Hoser, J. U. Hoffmann, R. S. Manna, T. Sarkar, and S. Thota, Neutron diffraction evidence for local spin canting, weak Jahn-Teller distortion, and magnetic compensation in TixMn1-xCo2O4 spinel, J. Phys.: Condens. Matter 32, 245801 (2020).",
        link: null,
        modal: false,
    },
    {
        title:
            'Arafat, Y., H. Yang, I. Dutta, Ajay Kumar P. , and B. Datta. "A Model for Intermetallic Growth in Thin Sn Joints Between Cu Substrates: Application to Solder Microjoints." Journal of Electronic Materials (2020): 1-16. \r\n DOI https://doi.org/10.1007/s11664-020-08019-8',
        link: "https://doi.org/10.1007/s11664-020-08019-8",
        modal: false,
    },
    {
        title:
            "Anup Basak, Valery I. Levitas (2020) Matrix-precipitate interface-induced martensitic transformation within nanoscale phase field approach: Effect of energy and dimensionless interface width, Acta Materialia, doi.org/10.1016/j.actamat.2020.02.047",
        link: null,
        modal: false,
    },
    {
        title:
            "H. Ammari, D. P. Challa, A. P. Choudhury and M.Sini.   The Equivalent Media Generated by Bubbles of High Contrasts: Volumetric Metamaterials and Metasurfaces. Multiscale Model. Simul. 18 (2020), no. 1, 240–293.",
        link: null,
        modal: false,
    },
    {
        title:
            "D. P. Challa,  F. Mouffouk,  M. Sini.   Estimation of a class of quasi-resonances generated by multiple small particles with high surface impedances. Math. Methods Appl. Sci. 42 (2019), no. 10, 3568–3578.",
        link: null,
        modal: false,
    },
    {
        title:
            "D. P. Challa, A. Mantile and M.Sini.   Characterization of the acoustic fields scattered by a cluster of small holes.  Asymptotic Analysis.  DOI: 10.3233/ASY-191560",
        link: null,
        modal: false,
    },
    {
        title:
            "H. Ammari, D. P. Challa, A. P. Choudhury and M.Sini.   The point-interaction approximation for the fields generated by contrasted bubbles at arbitrary fixed frequencies. J. Differential Equations 267 (2019), no. 4, 2104–2191.",
        link: null,
        modal: false,
    },
    {
        title:
            'Ravi Sharma and Venkataramana Badarla, "PCOC: A Fast Sensor-Device Line of Sight Detection Algorithm for Point Cloud Representations of Indoor Environments",  IEEE Communications Letters (accepted), February 2020.',
        link: null,
        modal: false,
    },
    {
        title:
            'Dipti Trivedi and Venkataramana Badarla, "Inferring Occupants Count from Low Power IP based Devices in Building through Data Fusion", 13th IEEE Internation Conference on Advanced Networks and Telecommunication Systems (IEEE ANTS), December 2019.',
        link: null,
        modal: false,
    },
    {
        title:
            "Anup Basak and Valery I Levitas,  An exact formulation for exponential-logarithmic transformation stretches in a multiphase phase field approach to martensitic transformations, Mathematics and Mechanics of Solids . DOI: 10.1177/1081286520905352",
        link: null,
        modal: false,
    },
    {
        title:
            "Alves, F., Leal- Filho, W., Casaleiro, P., …Jain, S., et al., 2020. Climate change policies and agendas: Facing implementation challenges and guiding responses. Environmental Science & Policy, 104:190-198.",
        link: null,
        modal: false,
    },
    {
        title:
            "Sharma, D., Jain, S., 2020. Reduction in black carbon concentration and its exposure in rural settings of Northern India: An intervention analysis. Chemosphere, 247, 125838.",
        link: null,
        modal: false,
    },
    {
        title:
            "The Prince by Nicolo Machiavelli (Classics in Philosophy New Series) Paperback – 1 Jan 2020 by A Raghuramaraju (Introduction) Nicolo Machiavelli (The Prince) (Author)",
        link: null,
        modal: false,
    },
    {
        title:
            "Sharma, D., Jain, S., 2020. Carcinogenic risk from exposure to PM2.5 bound polycyclic aromatic hydrocarbons in rural settings. Ecotoxicology and Environmental Safety 190, 110135.",
        link: null,
        modal: false,
    },
    {
        title:
            "Venigalla, A. S. M.; Lakkundi, C. S. & Chimalakonda, S., “PointerViz - Towards Visualizing Pointers for Novice Programmers”, 53rd International Hawaii International Conference on System Sciences, (HICSS), Jan 7-10, Grand Wailea, Maui, 2020 (Accepted)",
        link: null,
        modal: false,
    },
    {
        title:
            "Mishra Vishal; Reddy, S. K. & Chimalakonda, S., “Is there a Correlation Between Code Comments and Issues? - An Exploratory Study.”  The 35th ACM/SIGAPP Symposium On Applied Computing, Brno, Czech Republic, March 30-April 3, 2020 (Accepted)",
        link: null,
        modal: false,
    },
    {
        title:
            "Dhashade, A; Venigalla, A. S. M.; Chimalakonda, S., “Towards Prioritizing Github Issues”, 13th ACM Innovations in Software Engineering Conference  ISEC 2020, Jabalpur, India. (Accepted)",
        link: null,
        modal: false,
    },
    {
        title:
            "Venigalla, A. S. M.; Lakkundi, C. S. & Chimalakonda, S. “SOTagger - Towards Classifying Stack Overflow Posts through Contextual Tagging (S)”, The 31st International Conference on Software Engineering and Knowledge Engineering, SEKE 2019, Hotel Tivoli, Lisbon, Portugal, July 10-12, 2019., 2019, 493-639.",
        link: null,
        modal: false,
    },
    {
        title:
            "Chimalakonda, S., & Nori, K. V. (2019). “A Family of Software Product Lines in Educational Technologies.” To Appear in Computing Journal, Springer",
        link: null,
        modal: false,
    },
    {
        title:
            "Gundala, Upender, V. Vamshi Krishna Reddy, and Prabha Shankar Dwivedi. “Competence and Confidence through Technology enhanced Language Learning— The Impact of Technology among Rural and Semi-Urban Undergraduates of Engineering in India: A Study”, IEEE ICALT - 2019, DOI 10.1109/ICALT.2019.00084.",
        link: null,
        modal: false,
    },
    {
        title:
            "Dwivedi, Prabha Shankar. “W. B. Yeats’s Poetic Self and Indian Philosophy”, The Yeats Journal of Korea: An International Journal of Yeats and Modern Literature, Vol. 58, May 2019, 85-104 (DOI : http://dx.doi.org/10.14354/yjk.2019.58.85).",
        link: "http://dx.doi.org/10.14354/yjk.2019.58.85).",
        modal: false,
    },
    {
        title:
            "Dwivedi, Prabha Shankar. “Ontology of Dialogic Inquisition: A Study in Relation to Kena and Prasna Upanisads, and Bergsonism”, Journal of Comparative Literature and Aesthetics, Vol. 42, No. 1, March 2019, 64-72.",
        link: null,
        modal: false,
    },
    {
        title:
            "P. Sanlon, V. Sivakumar, B. Solan, S. Tripathy, P. Mackinnon, S. Donohue, and B. Janaki Ramaiah. “Assessment of Skempton's pore water pressure parameters B and A using a high-capacity tensiometer”, Geotechnique, 2019, Article in Press. https://doi.org/10.1680/jgeot.18.p.191",
        link: "https://doi.org/10.1680/jgeot.18.p.191",
        modal: false,
    },
    {
        title:
            "Aakash Yadav, PC Deshmukh, Ken Roberts, NM Jisrawi, and SR Valluri\r\n An Analytic Study of the Wiedemann-Franz Law\r\n and the Thermoelectric Figure of Merit\r\n      Journal of Physics Communications https://iopscience.iop.org/article/10.1088/2399-6528/ab444a/pdf",
        link: "https://iopscience.iop.org/article/10.1088/2399-6528/ab444a/pdf",
        modal: false,
    },
    {
        title:
            "P C Deshmukh\r\n     Foundations of Classical Mechanics\r\n     Cambridge University Press (1979), ISBN 9781108635639",
        link: null,
        modal: false,
    },
    {
        title:
            "U. Kannan, S. K. Prashanth, and S.M. Maliyekkal. Measurement, Analysis, and Remediation of Biological pollutants in the water, In Measurement, analysis, and remediation of environmental pollutants. Springer Nature, 211-242, 2020. https://doi.org/10.1007/978-981-15-0540-9_11.",
        link: "https://doi.org/10.1007/978-981-15-0540-9_11.",
        modal: false,
    },
    {
        title:
            "M.S.V.N. Jyothi, B.J. Ramaiah, and S.M. Maliyekkal. Occurrence, contamination, speciation, and analysis of selenium in the environment. In Measurement, analysis, and remediation of environmental pollutants. Springer Nature, 245-269, 2020. https://doi.org/10.1007/978-981-15-0540-9_12.",
        link: "https://doi.org/10.1007/978-981-15-0540-9_12.",
        modal: false,
    },
    {
        title:
            "V. Araya, S.M. Maliyekkal, L. Philip. “Water pollution and treatment technologies - Indian perspective”, Water Futures of India: Status of Science and Technology, Editors: P.P Mjumdar and V. M Tiwari, Indian National Science Academy, pp 215 -252, 2019.",
        link: null,
        modal: false,
    },
    {
        title:
            "Kotagi, P. B. and Asaithambi, G. (2019). Microsimulation Approach for Evaluation of Reversible Lane Operation on Urban Undivided Roads in Mixed Traffic. Transportmetrica A: Transport Science, Vol. 15, No.2, pp. 1613-1636.",
        link: null,
        modal: false,
    },
    {
        title:
            "Raj, P., Kalaanidhi, S., Asaithambi, G. and Ravi Shankar, A. U. (2019). Review of Methods for Estimation of Passenger Car Unit Values of Vehicles. Journal of Transportation Engineering, Part A: Systems, ASCE, Vol. 145, No. 6.",
        link: null,
        modal: false,
    },
    {
        title:
            "Oinam, R. M., Kumar, P. C. A., and Sahoo, D. R. (2019). “Cyclic performance of steel fiber-reinforced concrete exterior beam-column joints.” Earthquakes and Structures, 16(5), 533-546.",
        link: null,
        modal: false,
    },
    {
        title:
            "Soumyajit Saha, Jobin Jose, Pranawa C. Deshmukh, G. Aravind, Valeriy K. Dolmatov, Anatoli S Kheifets,and Steven T. Manson\r\nWigner time delay in photodetachment\r\nPhys. Rev. A 99, 043407 (2019)",
        link: null,
        modal: false,
    },
    {
        title:
            "Voma Uday Kumar, Gnaneswari Chitikela, Niharika Balasa, and P. C. Deshmukh\r\nRevisiting Table-Top Demonstration of Relativistic Time-Dilation and Length-Contraction\r\nBulletin of the Indian Association of Physics Teachers, 11:6, 172-179 (2019)",
        link: null,
        modal: false,
    },
    {
        title:
            "Soumyajit Saha, Pranawa C. Deshmukh, Anatoli S Kheifets, and Steven T. Manson\r\nDominance of correlation and relativistic effects on photodetachment time delay well above threshold\r\nPhys. Rev. A 99, 063413 (2019)",
        link: null,
        modal: false,
    },
    {
        title:
            "Kashyap, V. and Chaudhary, R. (2019, Forthcoming). Linking Employer Brand Image and Work Engagement: Modelling Organizational Identification and Trust in Organization as Mediators. South Asian Journal of Human Resources Management. (Accepted for publication)",
        link: null,
        modal: false,
    },
    {
        title:
            "Kashyap, V. and Verma, N. (2019). HRM Practices and Innovative Work Behavior: Role of Work Engagement and Organizational Norms. Paper accepted for presentation at 79th Annual meeting of Academy of Management (AOM), Boston, Massachusetts, USA.",
        link: null,
        modal: false,
    },
    {
        title:
            "Pooja Raj, Kalaanidhi Sivagnanasundaram, Gowri Asaithambi, Ayyalasomayajula Udaya Ravi Shankar (2019). Review of Methods for Estimation of Passenger Car Unit Values of Vehicles. Journal of Transportation Engineering, Part A: Systems, ASCE, Vol. 145, No. 6.",
        link: null,
        modal: false,
    },
    {
        title:
            "Sharma, D., Jain, S., 2019. Impact of intervention of biomass cookstove technologies and kitchen characteristics on indoor air quality and human exposure in rural settings of India. Environmental International, 123:240-255.",
        link: null,
        modal: false,
    },
    {
        title:
            "Joshi S., & Chimalakonda, S. (2019, May). RapidRelease - A Dataset of Projects and Issues on Github with Rapid Releases. To Appear In 2019 IEEE/ACM16th International Conference on Mining Software Repositories (MSR).",
        link: null,
        modal: false,
    },
    {
        title:
            "Manasa, S A., Lakkundi, S C., Agrahari V. & Chimalakonda, S. (2019, July). StackDoc - A StackOverﬂow plugin for Novice Programmers that Integrates Q&A with API Examples. To Appear In 2019 IEEE 19th International Conference on Advanced Learning Technologies (ICALT).",
        link: null,
        modal: false,
    },
    {
        title:
            "Manasa, S A., & Chimalakonda, S. (2019, July).  Towards Enhancing User Experience through a Web-based Augmented Reality Museum. To Appear In 2019 IEEE 19th International Conference on Advanced Learning Technologies (ICALT).",
        link: null,
        modal: false,
    },
    {
        title:
            "Calibrating Western Philosophy for India: Rousseau, Derrida, Deleuze, Guattari and Vaddera Chandidas, Routledge, London and New Delhi, 2019. [\r\n  Refer Book]",
        link: null,
        modal: false,
    },
    {
        title:
            "Sourav Banerjee, Pranawa C. Deshmukh, Valeriy K. Dolmatov, Steven T. Manson, and Anatoli S. Kheifets\r\n            Strong dependence of photoionization time delay on energy and angle in the neighborhood of Fano resonances\r\nPhys. Rev. A 99, 013416 (2019)",
        link: null,
        modal: false,
    },
    {
        title:
            "Deshmukh, Pranawa; Kumar, Ashish; Varma, Hari; Banerjee, Sourav ; Manson, Steven; Dolmatov, Valeriy; Kheifets, Anatoly\r\n            Wigner-Eisenbud-Smith photoionization time delay due to autoioinization resonances\r\nJ. Phys. B: Atomic, Molecular and Optical Physics, Volume 51, Number 6, 065008, (2018)",
        link: null,
        modal: false,
    },
    {
        title:
            "D. A. Keating, S. T. Manson, V. K. Dolmatov, A. Mandal, P. C. Deshmukh, Faiza Naseem, and A. S. Kheifets\r\nIntershell-correlation-induced time delay in atomic photoionization\r\nPhys. Rev. A 98, 013420 – Published 24 July 2018",
        link: null,
        modal: false,
    },
    {
        title:
            "Oinam, R. M., and Sahoo, D. R. (2019). “Using metallic dampers to improve seismic performance of soft-story RC frames : Experimental and numerical study.” Journal of Performance of Constructed Facilities, ASCE. 33(1), 1-18.",
        link: null,
        modal: false,
    },
    {
        title:
            "Oinam, R. M., and Sahoo, D. R. (2018). “Numerical evaluation of seismic response of soft-story RC frames retrofitted with passive devices.” Bulletin of Earthquake Engineering, 16(2), 983–1006.",
        link: null,
        modal: false,
    },
    {
        title:
            "Madan Mohan Avulapati, Thanos Megaritis, Jun Xia, Lionel Ganippa, Experimental understanding on the dynamics of micro-explosion and puffing in ternary emulsion droplets, Fuel, 239, pp 1284-1292 (2019), DOI:https://doi.org/10.1016/j.fuel.2018.11.112",
        link: "https://doi.org/10.1016/j.fuel.2018.11.112",
        modal: false,
    },
    {
        title:
            'Ravi Sharma and Venkataramana Badarla, "Analysis of a Novel Beacon Placement Strategy for 3D Localization in Indoor Spaces" accepted in 11th International Conference on COMmunication Systems and NETworkS (COMSNETS), January 2019.',
        link: null,
        modal: false,
    },
    {
        title:
            'Ravi Sharma and Venkataramana Badarla, "Geometrical Optimization of A Novel Beacon Placement Strategy for 3D Indoor Localization" accepted in IEEE ANTS workshop on Green ICT for Next Generation Wireless Networks, December 2018',
        link: null,
        modal: false,
    },
    {
        title:
            "M. Rajamani and S.M. Maliyekkal. Chitosan reinforced boehmite nanocomposite desiccant: A promising alternative to silica gel, Carbohydrate Polymers 194, 245-25, 2018. (Elsevier).",
        link: null,
        modal: false,
    },
    {
        title:
            "M. Mohandoss,  S.S. Gupta, R. Kumar, M.R. Islam,  A. Som,  A.G. Mohammed  T. Pradeep, S.M. Maliyekkal. Self-propagated combustion synthesis of few-layered graphene: an optical properties perspective, Nanoscale, 10, 7581-7588, 2018. (Royal Chemical Society).",
        link: null,
        modal: false,
    },
    {
        title:
            "D. Swathi, P. C. Sabumon, S.M. Maliyekkal, Anoxic ammonia removal using granulated nanoscale oxyhydroxides of Fe (GNOF) in a BR, Journal of Environmental Chemical Engineering,  6(4), 4273-428, 2018. (Elsevier).",
        link: null,
        modal: false,
    },
    {
        title:
            '"Bending Deleuze and Guattari for India: Re-Examining\r\nthe Relation Between Art and Politics in Europe and India," by A. Raghuramaraju, Department of Humanities and Social Sciences, Indian Institute of Technology Tirupati, India, published in the journal, Sophia  # Springer Nature B.V. 2018, Published online on 10 September 2018. https://doi.org/10.1007/s11841-018-0684-3',
        link: "https://doi.org/10.1007/s11841-018-0684-3,",
        modal: false,
    },
    {
        title:
            "Madan Mohan, A., Anand, T.N.C, Ravikrishna R.V., Atomization patterns produced by viscous, like-on impinging liquid jets, Forthcoming article, Journal of Flow Visualization and Image Processing, 2018, DOI:https://doi.org/10.1615/JFlowVisImageProc.2018027220",
        link: "https://doi.org/10.1615/JFlowVisImageProc.2018027220",
        modal: false,
    },
    {
        title:
            "P. Mohapatra, N. Pappas, J. Lee, T. Q. S. Quek, V. Angelakis, Secure communications for the two-user broadcast channel with random traffic, IEEE Transactions on Information Forensics and Security, vol. 13, no. 9, pp. 2294 - 2309, Sept. 2018.",
        link: null,
        modal: false,
    },
    {
        title:
            "A. Sinha, P. Mohapatra, J. Lee, and T. Q. S. Quek, On the Secrecy Capacity of 2-user Gaussian Interference Channel with Independent Secret Keys, in Proc. International Symposium on Information Theory and Its Applications (ISITA), Singapore, Oct. 2018 (Accepted).",
        link: null,
        modal: false,
    },
    {
        title:
            'D. Ghosh, S. Beniwal, A. Ganguli and A. Mukherjee, " Reference Free Imaging of Subsurface Cracks in Concrete using Rayleigh Waves", accepted in Structural Control and Health Monitoring, 2018.',
        link: null,
        modal: false,
    },
    {
        title:
            "G. Dey, A. Ganguli and B. Bhattacharjee, Electrical Conductivity, “Dielectric Permittivity and Degree of Saturation of Cement Mortar at Low Radio Frequencies”, accepted in  ASTM Journal of Testing and Evaluation, 2018.",
        link: null,
        modal: false,
    },
    {
        title:
            'B.Subramanian, N.Chokani and R.S.Abhari, 2018, "Impact of Atmospheric Stability on Wind Turbine Wake Evolution,” Journal of Wind Engineering and Industrial Aerodynamics, v.176, p. 74-82.',
        link: null,
        modal: false,
    },
    {
        title:
            "Oinam, R. M., and Sahoo, D. R. (2018). “Numerical evaluation of seismic response of soft-story RC frames retrofitted with passive devices.” Bulletin of Earthquake Engineering, 16(2), 983–1006.",
        link: null,
        modal: false,
    },
    {
        title:
            "Das, I. (2018): Robust Benchmark Dose Estimation using an Infinite Family of Response Functions. Human and Ecological Risk Assessment: An International Journal, 1-16.",
        link: null,
        modal: false,
    },
    {
        title:
            "Das, I. and Mukhopadhyay, S. (2018): Robust Designs for Multinomial Response Models. Communications in Statistics - Simulation and Computation (accepted).",
        link: null,
        modal: false,
    },
    {
        title:
            'Nithin V., Avan Rathod, Venkataramana Badarla, Tim Humernbrum, and Sergey Gorlatch, "Efficient Load Balancing for Multicast Traffic in Data Center Networks Using SDN", 10th IEEE International Conference on COMmunication Systems and NETworkS (COMSNETS) 2018.',
        link: null,
        modal: false,
    },
    {
        title:
            'Pradumn Kumar Pandey and Venkataramana Badarla, "Reconstruction of Network Topology using Status-time-series Data", Elsevier Journal Physica A, vol. 490, no. 15 pp. 573-583, 2018.',
        link: null,
        modal: false,
    },
    {
        title:
            "D. P. Challa, A.P. Choudhury and M. Sini. Mathematical Imaging Using Electric or Magnetic Nanoparticles as Contrast Agents. Inverse Problems and Imaging (IPI), 12(3), 573-605, 2018.",
        link: null,
        modal: false,
    },
    {
        title:
            "Wei Guo, V. Mahendran, Sridhar Radhakrishnan, “Join and Split TCP for SDN Networks: Architecture, Implementation, and Evaluation”, accepted in, Elsevier Computer Networks, 2018.",
        link: null,
        modal: false,
    },
    {
        title:
            "J. K. H. Fischer, P. Lunkenheimer, C. Leva, S. M. Winter, M. Lang, C. Mézière, P. Batail, A. Loidl, and R. S. Manna, Relaxation dynamics in the one-dimensional organic charge-transfer salt δ-(EDT-TTF-CONMe2)2Br, Phys. Rev. B 97, 235156 (2018).",
        link: null,
        modal: false,
    },
    {
        title:
            "M. Majumder$, R. S. Manna$, G. Simutis, J. C. Orain, T. Dey, F. Freund, A. Jesche, R. Khasanov, P. K. Biswas, E. Bykova, N. Dubrovinskaia, L.S. Dubrovinsky, R. Yadav, L. Hozoi, S. Nishimoto, A. A. Tsirlin, and P. Gegenwart, Breakdown of magnetic order in the pressurized Kitaev iridate β-Li2IrO3, Phys. Rev. Lett. 120, 237202 (2018), $ = equal contribution.",
        link: null,
        modal: false,
    },
    {
        title:
            "M. Fix, A. Jesche, S. G. Jantz, S. A. Braeuninger, H.-H. Klauss, R. S. Manna, I. M. Pietsch, H. A. Hoeppe, and P. C. Canfield, Ferromagnetism or slow paramagnetic relaxation in Fe-doped Li3N?, Phys. Rev. B 97, 064419 (2018).",
        link: null,
        modal: false,
    },
    {
        title:
            "R. S. Manna*, S. Hartmann, E. Gati, J. A. Schlueter, M. de Souza, and M. Lang, Low-temperature lattice effects in the spin-liquid-candidate system k-(BEDT-TTF)2Cu2(CN)3, Crystals 8, 87 (2018), *corresponding author; appeared in the special issue entitled ‘Advances in Organic Conductors and Superconductors’.",
        link: null,
        modal: false,
    },
    {
        title:
            "K. Zhao, J. K. Glasbrenner, H. Gretarsson, D. Schmitz, J. Bednarcik, M. Etter, J. P. Sun, R. S. Manna, A. Al-Zein, S. Lafuerza, W. Scherer, J. G. Cheng, and P. Gegenwart, Collapsed tetragonal phase as a strongly covalent and fully nonmagnetic state: persistent magnetism with interlayer As-As bond formation in Rh-doped Ca0.8Sr0.2Fe2As2, Phys. Rev. B 97, 020510 (R) (2018).",
        link: null,
        modal: false,
    },
    {
        title:
            "G. Dey, A. Ganguli, B. Bhattacharjee and T.K. Gandhi, “Potential of electrical response at low radio frequencies for moisture saturation assessment of cement mortar”, accepted in the Indian Concrete Journal, 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "P. Kumar, A. Ganguli, and G. S. Benipal, “Static and Dynamic Analysis of Cable-Suspended Concrete Beams, Structural Engineering and Mechanics”, vol. 64(5), pp.611-620, 2017",
        link: null,
        modal: false,
    },
    {
        title:
            "P. Kumar, A. Ganguli and G. S. Benipal, “Mechanics of Cable-Suspended Beams”, Latin American Journal of Solids and Structures, vol. 14(3), 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "Rajeswari B, Srivalsan, Ramarao N, and R. K. Sai S. Gorthi, “Active Learning Based Optimised Training Library Generation for Object Oriented Image Classification”, IEEE Transactions on Geo Science and Remote Sensing, Sept. 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "Rajesh, S., “On Existence of Fixed Points for Pointwise Eventually nullxpansive Mappings”, Journal of Fixed Point Theory and Applications, Volume 19, No. 3, Sept. 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "Saha, G., and K. P. Biligiri, “Novel Procedural Pragmatics of Dynamic Semi-Circular Bending Test for Fatigue Evaluation of Asphalt Mixtures”, Road Materials and Pavement Design, Taylor & Francis, UK, Sept. 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "Srinivasu, D. S. and N. Venkaiah, “Minimum Zone Evaluation of Roundness using Hybrid Global Search Approach”, International Journal of Advanced Manufacturing Technology, Volume 92, Issue 5–8, Sept. 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "Radhakrishnan, M., S. Rajesh, and S. Agarwal, “Some Fixed Point Theorems on Non-convex Sets”, Applied General Topology, Volume 18, No. 2, Oct. 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "Khan, V., and K. P. Biligiri, “Evolution of Tyre/Road Noise Research in India: Investigations using Statistical Pass-by Method and Noise Trailer”, International Journal of Pavement Research and Technology, Elsevier, UK, Oct. 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            'Gopakumar, G., M. Swetha, S. S. Gorthi, and R. K. Sai S. Gorthi, "CNN based Malaria Diagnosis from Focus-stack of Blood Smear Images Acquired using Custom-built Slide Scanner", Journal of Biophotonics, Nov. 2017.',
        link: null,
        modal: false,
    },
    {
        title:
            "Patnaik, U., P. K. Das, C. S. Bahinipati, and O. N. Tripathi, “Can Developmental Interventions Reduce Households' Vulnerability? Empirical Evidence from Rural India”, Current Science, 113(10), Nov. 2017",
        link: null,
        modal: false,
    },
    {
        title:
            'Mondal, P. C., V. Singh, A. K. Manna, and M. Zharnikov, "Covalently Assembled Monolayers of Homo‐and Heteroleptic FeII‐Terpyridyl Complexes on SiOx and ITO‐Coated Glass Substrates: An Experimental and Theoretical Study", Chemphyschem. 18(23), Dec. 2017.',
        link: null,
        modal: false,
    },
    {
        title:
            "Sharma R., and E. A. Kumar, “Study of Ammoniated Salts based Thermo Chemical Energy Storage System with Heat Up-gradation: A Thermodynamic Approach”, Energy, Volume 141, Dec. 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "Singh, V. K., and E. A. Kumar, “Thermodynamic Analysis of Single-stage and Single-effect Two-stage Adsorption Cooling Cycles using Indigenous Coconut Shell based Activated Carbon-CO 2 Pair”, International Journal of Refrigeration, Volume 84, Dec. 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "Patnaik, U., P. K. Das and C. S. Bahinipati, “Development Interventions, Adaptation Decisions and Farmers’ Well-being: Evidence from Drought Prone Households in Rural India”, Climate and Development, Dec. 2017.",
        link: null,
        modal: false,
    },
    {
        title:
            "Dwivedi, P. S., “A Study of Comparative Linguistico-Philosophical Foundations through the Translations of Bhartrhari and Saussure” International Journal of Translation, Vol. 29, Dec. 2017.",
        link: null,
        modal: false,
    },
];

export default PublicationScript;